import {useCallback, useMemo} from 'react';
import {useHalState} from '@synako/haligator';
import {useCadencier} from '@/haligator-factory';

/**
 * Hook indiquant si l'article est dans le cadencier du client.
 * Lit le champ scalaire `tri_selection` du cadencier.
 */
export function useEstDansCadencier(): (code_article: string) => boolean {
  const {data} = useHalState(useCadencier());
  const codes = useMemo(
    () =>
      new Set(
        data?.tri_selection.flatMap((groupe) =>
          groupe.articles.map((article) => article.code),
        ) ?? [],
      ),
    [data],
  );
  return useCallback(
    (code_article: string) => codes.has(code_article),
    [codes],
  );
}
